/**
 * Minúsculas, sem acentos e sem espaços nas pontas - para buscas tolerantes a acentuação
 * e caixa ("publicos" acha "públicos"). Usada pela busca da lista e pela busca de metas.
 */
export function normalizarTexto(s: string | null | undefined): string {
  return (s ?? '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
}

/** Corta o texto em `max` caracteres, com reticências - para rótulos de select e afins. */
export function truncar(s: string, max: number): string {
  return s.length <= max ? s : `${s.slice(0, Math.max(0, max - 1)).trimEnd()}…`;
}
